function SubNav() {
  const element = document.querySelector('.sub-nav');

  if (typeof element != "undefined" && element != null) {
    const target = element.offsetTop;
    window.onscroll = () => {
      if (window.pageYOffset >= target) {
        element.classList.add('sub-nav--fixed');
      } else {
        element.classList.remove('sub-nav--fixed');
      }
    }
  }
}

export default SubNav;


// WEBPACK FOOTER //
// ./src/js/app/components/SubNav.js